module.exports = __webpack_public_path__ + "52a1d054149d896fb1b2be2e44fc21c9.pdf";